import React from 'react';
import * as moment from 'moment';

import styles from './css/Audition.module.css';


class Audition extends React.PureComponent {

  render() {
    const { audition } = this.props;

    return (
      <div className={styles.amateurAuditionThumbnail}>
        <a className="lazy video" href={`/naked-amateur-auditions/${audition.slug}`}>
          <img
            alt="Xlthumb placeholder"
            className={styles.videoThumbnail}
            src={audition.image}
          />
        </a>
        <div className={styles.caption}>
          <h2 className={styles.captionTitle}>
            <a className={styles.captionLink} href={`/naked-amateur-auditions/${audition.slug}`}>{audition.title}</a>
          </h2>
          <small className={styles.captionDate}>{moment(audition.date).format('LL')}</small>
        </div>
      </div>
    );
  }
}

export default Audition;
